@for (category of categories(); track category.id) {
  <!-- Root level -->
  @if (category?.sub_categories?.length) {
    <webstore-menu-collapse
      (hideMenu$)="hideMenu()"
      (selectCategory$)="categorySelected($event)"
      [collapsed]="category?.id !== selectedCategoryId()"
      [sub_category]="category"
      [menuCollapseIcon]="menuCollapseIcon()"
      [headerLayout]="headerLayout()"
    >
      <!-- Child level -->
      @for (sub_category of category?.sub_categories; track sub_category.id) {
        @if (sub_category?.sub_categories?.length) {
          <webstore-menu-collapse-inner
            (hideMenu$)="hideMenu()"
            (selectSubCategory$)="subCategorySelected($event)"
            [collapsed]="sub_category?.id !== selectedSubCategoryId()"
            [sub_category]="sub_category"
            [menuCollapseIcon]="menuCollapseIcon()"
            [headerLayout]="headerLayout()"
          >
            <!-- Default ul/li for all layouts except layout-12 -->
            @if (!isLayout12()) {
            <ul class="link-menu-list-inner">
              @for (child_category of sub_category?.sub_categories; track child_category.id) {
                <li>
                  <a
                    [routerLink]="'category/' + child_category.url_path"
                    (click)="hideMenu()"
                    class="mobile-child-sub-menu"
                  >
                    {{ child_category?.name }}
                  </a>
                </li>
              }
            </ul>
            }

            <!-- Layout-12 specific ul/li - showing child category images -->
            @if (isLayout12()) {
            <ul class="link-menu-sub-child layout-12-sub-category-item">
              @for (child_category of sub_category?.sub_categories; track child_category.id) {
                <li class="link-menu-sub-child layout-12-sub-category-item menu-item-main-container">
                  <div class="layout-12-sub-wrapper menu-item-image-anchor-container">
                    <div class="combine-wrapper">
                      <div class="layout-12-sub-icon menu-item-image-container">
                        <img [id]="child_category.id" class="layout-12-sub-thumbnail menu-item-category-image" [src]="child_category.category_images || IMAGE_URLS.productEmptyState" />
                      </div>
                      <a
                        [routerLink]="'category/' + child_category.url_path"
                        (click)="hideMenu()"
                        class="mobile-child-sub-menu layout-12-child-link mobile-category-menu"
                      >
                        {{ child_category?.name }}
                      </a>
                    </div>
                  </div>
                </li>
              }
            </ul>
            }
          </webstore-menu-collapse-inner>
        } @else {
          <!-- Default ul/li for all layouts except layout-12 -->
          @if (!isLayout12()) {
          <ul class="link-menu-sub-child">
            <li>
              <a (click)="hideMenu()" class="mobile-sub-menu" [routerLink]="'category/' + sub_category.url_path">
                {{ sub_category?.name }}
              </a>
            </li>
          </ul>
          }

          <!-- Layout-12 specific ul/li - showing sub-category images -->
          @if (isLayout12()) {
          <ul class="link-menu-sub-child layout-12-sub-category">
            <li class="layout-12-sub-category-item menu-item-main-container">
              <div class="layout-12-sub-wrapper menu-item-image-anchor-container">
                <div class="combine-wrapper">
                  <div class="layout-12-sub-icon menu-item-image-container">
                    <img [id]="sub_category.id" class="layout-12-sub-thumbnail menu-item-category-image" [src]="sub_category.category_images || IMAGE_URLS.productEmptyState" />
                  </div>
                  <a (click)="hideMenu()" class="mobile-sub-menu mobile-category-menu layout-12-sub-link" [routerLink]="'category/' + sub_category.url_path">
                    {{ sub_category?.name }}
                  </a>
                </div>
              </div>
            </li>
          </ul>
          }
        }
      }
    </webstore-menu-collapse>
  } @else {
    @if (!isLayout12()) {
    <ul class="non-collapse-list">
      <li>
        <a class="mobile-category-menu" [routerLink]="'category/' + category.url_path" (click)="hideMenu()">
          {{ category?.name }}
        </a>
      </li>
    </ul>
    }

    <!-- Layout-12 specific ul/li - keeping same structure but with different styling -->
    @if (isLayout12()) {
    <ul class="non-collapse-list layout-12-dynamic-single link-menu-sub-child">
      <li class="layout-12-dynamic-single-item layout-12-sub-category-item menu-item-main-container">
        <div class="layout-12-single-wrapper layout-12-sub-wrapper menu-item-image-anchor-container">
          <div class="combine-wrapper">
            <div class="layout-12-single-icon layout-12-sub-icon menu-item-image-container">
              <img [id]="category.id" class="layout-12-single-thumbnail category-image layout-12-sub-thumbnail menu-item-category-image" [src]="category.category_images || IMAGE_URLS.productEmptyState" />
            </div>
            <a class="mobile-category-menu layout-12-single-link mobile-category-menu" [routerLink]="'category/' + category.url_path" (click)="hideMenu()" [id]="category.id">
              {{ category?.name }}
            </a>
          </div>
        </div>
      </li>
    </ul>
    }
  }
}
